<script>
  import { createEventDispatcher } from "svelte";
  import { Circle } from "svelte-loading-spinners";
  import Select from "svelte-select";
  import config from "../../../stores/config";
  import Modal from "./../../../shared/Modal.svelte";
  import MaterialRow from "./MaterialRow.svelte";
  import * as ls from "local-storage";
  import axios from "axios";
  import MaterialHeader from "./MaterialHeader.svelte";
  const dispatch = createEventDispatcher();

  let authData = { headers: { authorization: ls.get("jwt") } };

  export let orderID;
  export let styleID;
  export let materialReq;
  let material;

  const emptyNewMat = {
    itemID: null,
    qtyReq: null,
    qtyUsed: 0,
    qtyWasted: 0,
    uPrice: null,
  };

  let newMat = { ...emptyNewMat };

  let showAddNewMatForm = false;
  let addNewMatLoading = false;

  const handleAddNewMat = async (e) => {
    if (!material) alert("⚠ Material name missing!");
    else if (newMat.qtyReq == undefined) alert("⚠ Quantity Required missing!");
    else if (newMat.qtyUsed == undefined) alert("⚠ Qty Used missing!");
    else if (newMat.qtyWasted == undefined) alert("⚠ Qty Wasted missing!");
    else {
      addNewMatLoading = true;

      let data = {
        ...newMat,
        itemID: material.value,
        uPrice: material.price,
      };

      axios
        .put(
          `${$config.backendURL}/orders/${orderID}/add-material/${styleID}`,
          data,
          authData
        )
        .then((res) => {
          showAddNewMatForm = false;
          addNewMatLoading = false;
          newMat = { ...emptyNewMat };
          dispatch("reloadData");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
</script>

<Modal
  show={showAddNewMatForm}
  on:modalClose={() => {
    showAddNewMatForm = false;
  }}
>
  <div class="grid gap-y-2 pb-10">
    <div class="grid grid-cols-3 gap-2 items-center">
      <div>Select Material :</div>
      <div class="col-span-2">
        <Select
          items={$config.items}
          on:select={(e) => (material = e.detail)}
        />
      </div>
    </div>

    <div class="grid grid-cols-3 gap-2 items-center">
      <div>Quantity Required :</div>
      <input
        class="col-span-2"
        bind:value={newMat.qtyReq}
        type="number"
        step="any"
        placeholder="Quantity or meters required"
      />
    </div>

    {#if addNewMatLoading}
      <div class="flex items-center justify-center btn btn-green-outline">
        <Circle size="25" color="rgb(16, 185, 129)" unit="px" />
        <span class="ml-4">Please wait...</span>
      </div>
    {:else}
      <!-- else content here -->
      <div class="flex">
        <button
          style="width: 100%;"
          class="btn btn-green"
          on:click={handleAddNewMat}
        >
          <i class="fas fa-check-circle mr-3" />
          Save
        </button>
        <button
          style="width: 100%;"
          class="ml-4 btn btn-gray"
          on:click={(e) => (showAddNewMatForm = false)}
        >
          <i class="fas fa-times-circle mr-3" />
          Close
        </button>
      </div>
    {/if}
  </div>
</Modal>

<div class="grid grid-cols-1 gap-4">
  <button
    class="btn btn-green"
    on:click={(e) => (showAddNewMatForm = true)}
    style="width: 100%;"
  >
    <i class="fas fa-plus-circle mr-3" />
    Add new material requirement
  </button>
</div>

{#if materialReq == null}
  <div class="loading-screen h-screen flex items-center justify-center">
    <Circle size="50" color="rgb(16, 185, 129)" unit="px" />
  </div>
{:else}
  <div
    class="mt-6 bg-white rounded-md shadow-sm w-full overflow-auto text-gray-500 text-sm"
  >
    <MaterialHeader />
    {#each materialReq as mat (mat._id)}
      <div class="">
        <MaterialRow
          {...mat}
          {orderID}
          {styleID}
          on:delete={() => dispatch("reloadData")}
          on:update={() => dispatch("reloadData")}
        />
      </div>
    {:else}
      <div class="col-span-full">
        <div class="h-52 w-full flex items-center justify-center uppercase">
          No material for the style yet...
        </div>
      </div>
    {/each}
  </div>
{/if}
